import { CircularProgress, Box, styled } from '@mui/material';

// STYLED COMPONENT
const StyledLoading = styled('div')({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
        height: '30px',
        width: '30px',
    },
    '& .circleProgress': {
        position: 'absolute',
        left: -5,
        right: 0,
        top: 'calc(50% - 22.2px)',
    },
});

export default function Loading() {
    return (
        <StyledLoading>
            <Box position="relative">
                {/* <img src="/assets/images/toor.png" alt="" /> */}
                <CircularProgress className="circleProgress" sx={{ color: 'var(--primary-theme-color)' }}  />
            </Box>
        </StyledLoading>
    );
}
